import { IRouteViewModel, NavigationInstruction, Params, RouteNode } from '@aurelia/router-lite';
import { Helper } from '../../resources/extensions';
import { inject } from 'aurelia';

import './unknown-route.scss';

@inject(Helper)
export class UnknownRoute implements IRouteViewModel {
    message: string = 'We apologize for the inconvenience, but the page you are attempting to access is unavailable. It may have been relocated or deleted, or the URL may have been entered incorrectly. Please confirm the accuracy of the URL. In the meantime, we invite you to explore other sections of our website. Should you require further assistance, please do not hesitate to contact our support team.';
    static path = 404;
    static title = '404 - Page Not Found';

    constructor(private helper: Helper) { }

    public canLoad(params: Params, next: RouteNode): boolean | NavigationInstruction {
        const fragment = next.instruction?.component.value;
        if (fragment !== '404') return '404';
        return true;
    }

    attached() {
        this.helper.handlePrerender404();
    }

    dispose() {
        this.helper.removePrerender404MetaTag();
    }
}
